import styled from "styled-components";
import { BaseStyle } from "./styled";

export const MypageStyle = styled(BaseStyle)`
  .logout {
    border: none;
    background: none;
  }
  .tab-content {
    text-align: start;
  }
  .card {
    max-width: 200px;
  }
  .nav-link {
    color: black;
  }

  .nav-active {
    color: grey;
  }
`;
